import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import commonStore from "./modules/common";
import userStore from "./modules/user";

Vue.use(Vuex);

const store = new Vuex.Store({
	/**
	 * 在开发环境中开启严格模式
	 * 严格模式下，只能通过 mutation 来修改 state，这能保证所有的状态变更都能被调试工具跟踪到
	 */
	strict: process.env.NODE_ENV !== "production",
	modules: {
		user: userStore,
		common: commonStore
	},
	getters: {
		token: (state) => state.user.token,
		userInfo: (state) => state.user.userInfo,
		permissions: (state) => state.user.permissions,
		currencySymbol: (state) => {
			if (!state.user.userInfo.currency_setting) {
				return "¥";
			}

			return state.user.userInfo.currency_setting.symbol;
		},
		menuMarkersCounts: (state) => state.common.menuMarkersCounts
	},
	plugins: [
		createPersistedState({
			storage: window.localStorage,
			reducer(val) {
				const { user, common } = val;
				// eslint-disable-next-line no-unused-vars
				const { initRoute, ...rest } = user;

				return {
					user: rest,
					common
				};
			}
		})
	]
});

export default store;
